module.exports = __webpack_public_path__ + "static/media/wildlings_track.0676798f.png";